import { useEffect, useState } from 'react';
import { useConnection } from '../../connection/Application';
import { CbaPaperDetail, readBody } from './cbaApi';

/**
 * A paper's details, for pages whose own payload names the paper but not its
 * subject or grade. Without them the breadcrumb is just shorter, so a failure
 * is not reported.
 */
const usePaperDetail = (paperId: string | undefined): CbaPaperDetail | undefined => {
  const connection = useConnection();
  const [detail, setDetail] = useState<CbaPaperDetail>();

  useEffect(() => {
    if (!paperId) {
      return;
    }
    let current = true;
    connection
      .get(`cba/papers/${paperId}`)
      .then((response: any) => current && setDetail(readBody<CbaPaperDetail>(response)))
      .catch(() => current && setDetail(undefined));
    return () => {
      current = false;
    };
  }, [connection, paperId]);

  return detail;
};

export default usePaperDetail;
